import { ReCAPTCHA } from "@lib/recaptcha";
import { GenericZodSchemaFormValidation } from "@lib/validation/utils";
import { trainingRequestSchema } from "./schema";

export declare var grecaptcha: ReCAPTCHA;
export { modalManager } from "@lib/modal/modalManager";

function startRequest() 
{
    const section = document.querySelector('.training-pill');
    const elements = section?.querySelectorAll('.training-pill__item .col-12');
    
    section?.classList.add('training-pill--showrequest');
    elements?.forEach(item => {
        item.classList.remove('col-12');
        item.classList.add('col-10');
    });
}


function SelectTrainingItem(event: Event)
{
    const element = event.currentTarget as HTMLButtonElement;
    if (element) 
    {
        const item = element.closest('.training-pill__item');
        item?.classList.add('added');
    }

    UpdateValues();
}

function DeSelectTrainingItem(event: Event)
{
    const element = event.currentTarget as HTMLButtonElement;
    if (element) 
    {
        const item = element.closest('.training-pill__item');
        item?.classList.remove('added');
    }

    UpdateValues();
}

function UpdateValues()
{
    const ids = document.getElementById('selectedIds') as HTMLInputElement;
    const idsSelected = document.querySelectorAll('.training-pill__item.added') as NodeListOf<HTMLDivElement>;

    const idsArray: string[] = [];
    idsSelected.forEach(item => idsArray.push(item.dataset.id ?? ""))
    ids.value = idsArray.map(item => item).join(',');
}

function cancelRequest() 
{
    const section = document.querySelector('.training-pill');
    const elements = section?.querySelectorAll('.training-pill__item .col-12');
    const removes = section?.querySelectorAll('.training-pill__actions-remove');
    const adds = section?.querySelectorAll('.training-pill__actions-add');

    removes?.forEach(item => {
        const e = item.closest('.training-pill__item');
        e?.classList.remove('added');
    })


    section?.classList.remove('training-pill--showrequest');
    elements?.forEach(item => {
        item.classList.remove('col-10');
        item.classList.add('col-12');
    });
}

export function Initialize()
{
    const requestButtons = document.querySelectorAll(".training-pill__request");
    const cancelButtons = document.querySelectorAll('.training-pill__cancel');
    const addButtons = document.querySelectorAll('.training-pill__actions-add');
    const removeButtons = document.querySelectorAll('.training-pill__actions-remove');
    
    requestButtons?.forEach(item => item.addEventListener('click', startRequest));
    cancelButtons?.forEach(item => item.addEventListener('click', cancelRequest));    
    addButtons?.forEach(item => item.addEventListener('click', SelectTrainingItem));    
    removeButtons?.forEach(item => item.addEventListener('click', DeSelectTrainingItem));    
}

export async function ValidateForm(event: Event) 
{
    const response = grecaptcha.getResponse();
    
    if (response != "")
    {
        const form = event.currentTarget as HTMLFormElement;
        const status = GenericZodSchemaFormValidation<typeof trainingRequestSchema>(form, trainingRequestSchema, event);
    }

    event.preventDefault();
    alert('Please check I am not a robot.');
}